import { LOGIN_TYPE } from '../constants/login';

export const getMasterAccountId = () => {
  const masterAccount = JSON.parse(localStorage.getItem('masterAccount'));
  if (!masterAccount || !masterAccount?.id) {
    return null;
  }

  return masterAccount.id;
};

export const hasDiffAccountIdOnPlannerTool = () => {
  const guestId = localStorage.getItem('guestId');
  const member = JSON.parse(localStorage.getItem('member'));
  const masterAccountId = getMasterAccountId();

  if (!masterAccountId) {
    return false;
  }

  if (guestId === masterAccountId) {
    return false;
  }

  // it is a guest account from other 3th party
  if (
    member &&
    masterAccountId === member._id &&
    member.loginType === LOGIN_TYPE.GUEST
  ) {
    return false;
  }

  return true;
};
